// Resolves a LessonRow into a single-language view of its content.
// `translations.es` (or any other lang) overrides the base English columns
// per-field; missing fields fall back to English. This mirrors the demo's
// "lessons not yet translated will appear in English" behavior.

type Play = { t: string; d: string };

type LessonLike = {
  title: string;
  hook: string | null;
  insight: string | null;
  plays: Play[] | null;
  why: string | null;
  expect: string | null;
  translations: Record<
    string,
    {
      title?: string;
      hook?: string | null;
      insight?: string | null;
      plays?: Play[] | null;
      why?: string | null;
      expect?: string | null;
    }
  > | null;
};

export type LocalizedLesson<L extends LessonLike> = Omit<L, 'translations'>;

export function localizeLesson<L extends LessonLike>(
  lesson: L,
  language: string,
): LocalizedLesson<L> {
  const tr = lesson.translations?.[language];
  if (!tr) {
    const { translations: _drop, ...rest } = lesson;
    return rest as LocalizedLesson<L>;
  }
  const { translations: _drop, ...rest } = lesson;
  return {
    ...rest,
    title: tr.title ?? lesson.title,
    hook: tr.hook ?? lesson.hook,
    insight: tr.insight ?? lesson.insight,
    plays: tr.plays ?? lesson.plays,
    why: tr.why ?? lesson.why,
    expect: tr.expect ?? lesson.expect,
  } as LocalizedLesson<L>;
}
